import React, { Fragment } from 'react'
import { FormGroup, Row, Col, Nav, Container, NavLink, Form, Card, CardBody, Button, Table } from 'reactstrap';
import 'animate.css';
import './styleCash.css';
import { useCash } from '../../hooks/cash/useCash';
import { ModalPreviewTicket } from './ModalPreviewTicket';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { FaFilePdf } from 'react-icons/fa';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import mujerImage from '../../assets/images/user/mujer.png';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import { ConfigServer } from '../../data/config'
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { ScrollTop } from 'primereact/scrolltop';




export const IndexCash = () => {

    let branchs = localStorage.getItem('branchName');

    const {
        //*CONFIGURATION CASH
        formCash, capture_amount, handleInputChangeCash,

        //*INDICATORS
        cancell, discountT, comments, saveCreate, formatter, totalCancell, totalPatients,

        //*HISTORIC
        dataHistoric, dateInit, dateEnd, changeDate, handleHistoric, typeAmoun, amountfin,

        //*FINAL REPORT
        dataDevolution,

        //*FINAL REPORT TYPE COMPANY
        number_format, sumPayMethods,

        //*PRINT TICKETS
        modalPrint, toggleModalPrint, handleViewTickets, printTicket, loadingPrint, loadingCreate, downloadExcel, _type_client,

        //* CASH and CREDIT
        downloadExcelCredits, downloadExcelOthers, dataUserReport, globalFilter, setGlobalFilter,
        _commercialLine, _nameUser, _branchName, loadingReport, getBadgePatient, getBadgeStatus, customBody,
        visibleTicket, showModalTicket, hideModalTicket
    } = useCash();


    let wilso = amountfin[0]
    let _arrayNew = ""
    let _total = ""

    if (_type_client === "https://insan.helen-sw.com" && amountfin.length > 0) {
        _arrayNew = amountfin[0]
        _total = _arrayNew["EFECTIVO"]?.Amount
    }


    const footerContent = <div>
        <Button disabled={loadingCreate ? true : false} size="sm" outline color="secondary" type="button" onClick={() => saveCreate()} >{"Generar corte"}</Button>
        <Button disabled={loadingCreate ? true : false} size="sm" className="btn-air-light" outline color="danger" type="button" onClick={hideModalTicket}>Cancelar</Button>
    </div>



    //!FECH NEW
    const now = new Date();
    const fecha = now.toLocaleDateString();
    const hora = now.toLocaleTimeString();
    let _new = (fecha + " " + hora)


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };



    return (
        <Fragment>
            <div>
                <div className="customizer-links" style={{ width: "45px" }} >
                    <Nav className="flex-column nac-pills">
                        <NavLink onClick={showModalTicket}   >
                            <div className="settings"  >
                                <i className="fa fa-calendar-o f-18"></i>
                            </div>
                            <span>{"Generarar cortes"}</span>
                        </NavLink>
                        <NavLink onClick={() => handleViewTickets()}  >
                            <div className="settings" >
                                <i className="icofont icofont-printer f-18"></i>
                            </div>
                            <span>{"Reemprimir cortes"}</span>
                        </NavLink>
                    </Nav>
                </div>

                <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                        <Card
                            style={{
                                marginBottom: '15px',
                                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                            }}
                        >
                            <CardBody style={{ padding: '18px 25px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                        </div>
                                        <div>
                                            <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                                Corte de caja
                                            </h4>
                                            <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                                <i className="fa fa-info-circle mr-1"></i>
                                                Detallado de los registros realizados por el usuario al dia.
                                            </small>
                                        </div>
                                    </div>

                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                {
                    // * CASH
                }
                <div style={{ scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left" }}>
                    <Row className="mt-0 mb-3">
                        {
                            // * ACCORDIAN
                        }
                        <Col sm="12" className='pt-0' >
                            <Accordion activeIndex={0}>
                                <AccordionTab
                                    header={
                                        <span className="flex items-center gap-6 w-full">
                                            {

                                                sumPayMethods === 0 ?
                                                    ""
                                                    :
                                                    <>
                                                        <span style={{ fontSize: "15px" }} className="font-bold text-xs whitespace-nowrap mr-auto ml-4 txt-secondary">{"Total registrado:"}</span>
                                                        <Badge value={(sumPayMethods ?? 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })} className="ml-1" />
                                                        <span style={{ fontSize: "15px" }} className="font-bold text-xs whitespace-nowrap mr-auto ml-4 txt-secondary">{"Responsable:"}</span>
                                                        <span style={{ fontSize: "15px" }} className="font-bold text-xs whitespace-nowrap mr-auto ml-1">{_nameUser}</span>
                                                    </>
                                            }
                                        </span>
                                    }
                                >

                                    <DataTable
                                        className="data-table"
                                        value={dataUserReport}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 20, 50]}
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "25%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                    No se a generada ningún ingreso.
                                                </p>
                                            </div>
                                        }
                                        header={
                                            <Col sm="12" className='p-l-0 p-r-0'>
                                                <Row>

                                                    <Col sm="2">
                                                        <div style={{
                                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                                        }}>
                                                            <label htmlFor="">Total de pacientes:</label> &nbsp;
                                                            <b className='f-w-600'>
                                                                {totalPatients ?? 0}
                                                            </b>
                                                        </div>
                                                    </Col>
                                                    <Col sm="3">
                                                        <div style={{
                                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                                        }}>
                                                            <label htmlFor="">Total en descuentos:</label> &nbsp;
                                                            <b className='f-w-600'>
                                                                ${(number_format(discountT ?? 0, 2))}
                                                            </b>
                                                        </div>
                                                    </Col>

                                                    <Col sm="2">
                                                        <div style={{
                                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                                        }}>
                                                            <label htmlFor="">Ordenes Canceladas</label> &nbsp;
                                                            <b className='f-w-600'>
                                                                {totalCancell ?? 0}
                                                            </b>
                                                        </div>
                                                    </Col>
                                                    <Col sm="3">
                                                        <div style={{
                                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                                        }}>
                                                            <label htmlFor="">Ingreso Cancelado</label> &nbsp;
                                                            <b className='f-w-600'>
                                                                $ {number_format(dataDevolution ?? 0, 2)}
                                                            </b>
                                                        </div>
                                                    </Col>
                                                    <Col sm="2" className='pt-3' >
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText
                                                                type="search"
                                                                className="pl-6"
                                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                                style={{ textAlign: "right" }}

                                                            />
                                                        </span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                        globalFilter={globalFilter}
                                    >
                                        <Column field="nim" header="Solicitud (NIM)" sortable body={customBody} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="typeClientUser" header="Paciente" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="name_branches" header="Sucursal" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column
                                            field="type"
                                            header="Tipo de ingreso"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.type;
                                                return (

                                                    <Badge
                                                        value={label}
                                                        severity={getBadgePatient(label)}
                                                        style={{ textAlign: "center", fontSize: "10px" }}
                                                    />
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />
                                        <Column field="cash" header="E" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="creditCard" header="T.C" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="debitCard" header="T.D" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="electronicTransfer" header="T" headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="credit" header="C" headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="amount" header="Total" sortable headerStyle={headerStyle} style={centerStyle} />

                                        <Column
                                            field="type"
                                            header="Facturado"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.is_invoice;

                                                return (
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <FaFilePdf style={{ marginRight: "5px", color: label === "Pendiente" ? "#dc3545" : "#28a745", fontSize: "16px" }} />
                                                    </div>
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />
                                        <Column
                                            field="status"
                                            header="Estatus de orden"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.status;
                                                return (
                                                    <Badge
                                                        value={label}
                                                        severity={getBadgeStatus(label)}
                                                        style={{ textAlign: "center", fontSize: "10px" }}
                                                    />
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />

                                    </DataTable>
                                </AccordionTab>
                                {
                                    dataHistoric.length > 0 ?
                                        <AccordionTab
                                            header={
                                                <span className="flex items-center gap-6 w-full">
                                                    <Avatar image={mujerImage} shape="circle" size="large" />
                                                    <span style={{ color: "#F59E0B" }} className="font-bold text-xl whitespace-nowrap mr-auto ml-4">{"Recibos del corte"}</span>
                                                    {
                                                        dataHistoric.map(_find => {
                                                            return <>
                                                                <span className="font-bold text-xs whitespace-nowrap mr-auto ml-4 txt-secondary">{"Ticket:"}</span>
                                                                <img
                                                                    src={require("../../assets/images/price/pdf.svg")}
                                                                    alt="PDF"
                                                                    title="Ticket de Corte PDF"
                                                                    style={{ cursor: "pointer", width: "36px", height: "36px" }}
                                                                    onClick={() => printTicket(_find.id_cash_flow, 0)}
                                                                />
                                                                <span className={_type_client === cedimi ? "font-bold text-xs whitespace-nowrap mr-auto ml-4 txt-secondary" : "d-none"} >{"Reporte contado:"}</span>
                                                                {
                                                                    _type_client === cedimi && <img
                                                                        src={require("../../assets/images/price/cash.svg")}
                                                                        alt="excel"
                                                                        title="excel contado"
                                                                        style={{ cursor: "pointer", width: "36px", height: "36px" }}
                                                                        onClick={() => downloadExcelOthers(_find.id_cash_flow, 0)}
                                                                    />
                                                                }
                                                                <span className={_type_client === cedimi ? "font-bold text-xs whitespace-nowrap mr-auto ml-4 txt-secondary" : "d-none"} >{"Reporte credito:"}</span>
                                                                {
                                                                    _type_client === cedimi && <img
                                                                        src={require("../../assets/images/price/credit.svg")}
                                                                        alt="excel"
                                                                        title="excel creditoF"
                                                                        style={{ cursor: "pointer", width: "36px", height: "36px" }}
                                                                        onClick={() => downloadExcelCredits(_find.id_cash_flow, 0)}
                                                                    />
                                                                }

                                                                {
                                                                    loadingReport && <i className="fa fa-spin fa-spinner font-primary ml-4 f-26"></i>
                                                                }
                                                            </>
                                                        })
                                                    }
                                                </span>
                                            }
                                        >
                                        </AccordionTab>
                                        : ""
                                }
                            </Accordion>
                            <br /> <br />
                        </Col>
                    </Row>
                </div>




            </div>
            <ModalPreviewTicket
                {
                ...{ modalPrint, toggleModalPrint, dataHistoric, printTicket, loadingPrint, downloadExcel, handleHistoric, dateEnd, dateInit, changeDate, downloadExcelCredits, downloadExcelOthers }
                }
            />


            {
                // ? DIALOG
            }
            <Dialog visible={visibleTicket} style={{ width: '70vw' }} header={null} closable={false} onHide={hideModalTicket} footer={footerContent}>
                <Col sm="12" className='p-r-0 p-l-0'  >
                    {
                        dataUserReport.length === 0 && <div className="text-center">
                            <img
                                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "30%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "12px" }}>
                                No se a generada ningún ingreso asi que no hay corte pendiente.
                            </p>
                        </div>
                    }
                    <Row className={dataUserReport.length > 0 ? "" : "d-none"} >

                        <Col sm="5" className='p-l-0 p-r-0' style={{ backgroundColor: "#fff" }}   >
                            <Col className="socialprofile filter-cards-view p-l-0 p-b-0 p-r-0">
                                {
                                    <>
                                        <Col sm="12" style={loadingCreate ? { filter: "opacity(0.5)" } : { width: '400px', height: '400px', 'overflow': 'auto' }}    >
                                            <div style={{ transform: 'scale(0.9)', transformOrigin: 'top left' }}>
                                                <Col sm="12" style={{ textAlign: "center" }} >
                                                    <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "35%" }} alt="logo" />
                                                </Col>
                                                <Row>
                                                    <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                        <label className='f-14 f-w-600'>{_commercialLine} </label> <br />
                                                        <label style={{ fontSize: "11px" }} className=' f-w-600'>{_branchName} </label> <br />
                                                        <div className='preview-cash-div' ></div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12" >
                                                        <Col sm="12" style={{ textAlign: "center" }}>
                                                            <label style={{ fontSize: "10px" }} >DETALLE</label>
                                                        </Col>
                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ color: "#000", textAlign: "center" }} > <label className='f-w-600 f-12'>Fecha de inicio</label></th>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>Fecha de corte</label></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                                        <td>{_new ?? "---------"}</td>
                                                                        <td>{_new ?? "---------"}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>

                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>MÉTODO DE PAGO</label></th>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>TOTAL</label></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        typeAmoun?.length > 0 && typeAmoun?.sort() && typeAmoun?.map((_find, index) => {
                                                                            return <tr key={_find} className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                                                <td>{_find ?? "----"}</td>
                                                                                <td><label className='f-12 f-w-600 '>{formatter.format(wilso[_find].Amount !== undefined && wilso[_find].Amount)}</label></td>
                                                                            </tr>
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        </div>

                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle de movimientos</td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Descuentos</b></td>
                                                                        <td className="text-center"><b className='f-12'>$ {number_format(discountT ?? 0, 2)}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Cancelaciones</b></td>
                                                                        <td className="text-center "><b className='f-12'>$ {number_format(cancell ?? 0, 2)}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Total</b></td>
                                                                        <td className="text-center "><b className='f-12'>$ {number_format(sumPayMethods ?? 0, 2)}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Efectivo registrado</b></td>
                                                                        <td className="text-center "><b className='f-12'>$ {number_format(formCash.capture_amount ?? 0, 2)}</b></td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            <br />
                                                            <b htmlFor="">{formCash.comments ?? "--------"}</b>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }}>
                                                        <div className='preview-cash-div' ></div>
                                                        <label style={{ fontSize: "11px" }} className=' f-w-600'>{_nameUser} </label> <br />
                                                    </Col>
                                                </Row>

                                            </div>

                                        </Col>
                                        <ScrollTop target="parent" threshold={20} className="w-2rem h-2rem border-round bg-primary" icon="pi pi-arrow-up text-base" />
                                    </>
                                }
                            </Col>
                        </Col>
                        <Col sm="6"  >
                            <div className='hr-detail-patient'>
                                <i className="fa fa-circle-o text-info f-12 pt-2"></i>&nbsp;<label className='f-w-600 pt-2' style={{ fontSize: "13px" }}>Generar corte de caja</label>
                            </div> <br />
                            {
                                loadingCreate ?
                                    <>
                                        <Row>
                                            <Col sm="12" md="12" lg="12" className='text-center'>
                                                <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "20%" }} />
                                            </Col>
                                            <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                                <p>Generando corte...</p>
                                            </Col>
                                        </Row>
                                    </>

                                    :
                                    <div className=' p-1'  >
                                        <div style={{
                                            backgroundColor: 'white', border: '1px solid #e0e0e0',
                                            borderRadius: '10px', padding: '12px', fontSize: '12px'
                                        }}>
                                            <Row>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "11px" }}>
                                                        <i className="fa fa-circle text-info"></i>  Responsable: <label className='txt-secondary f-w-600'>&nbsp;{_nameUser ?? "-----"}</label>
                                                    </label>
                                                </Col>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "11px" }}>
                                                        <i className="fa fa-circle text-info"></i>  Sucursal: <label className='txt-secondary f-w-600'>&nbsp;{branchs ?? "-----"}</label>
                                                    </label>
                                                </Col>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "11px" }}>
                                                        <i className="fa fa-circle text-info "></i>  Monto a reportar en caja: <label className='f-w-600 f-12'>&nbsp;{formatter.format(formCash.capture_amount ?? 0)}</label>
                                                    </label>
                                                </Col>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "11px" }}>
                                                        <i className="fa fa-circle text-info"></i>  Efectivo: <input disabled={_type_client === "https://insan.helen-sw.com" ? true : false} type="number" className='inputCash f-12' placeholder={_type_client === "https://insan.helen-sw.com" ? "" : 'Ingrese la cantidad'} value={_type_client === "https://insan.helen-sw.com" ? _total ?? 0 : capture_amount} name="capture_amount" onChange={handleInputChangeCash} />
                                                    </label>
                                                </Col>
                                                <Col sm="12" md="12" lg="12">
                                                    <label style={{ fontSize: "11px" }}>
                                                        <i className="fa fa-circle text-info"></i>  Oberservaciones:
                                                    </label>
                                                    <textarea
                                                        className='form-control form-control-sm input-air-primary'
                                                        name="comments"
                                                        rows="3"
                                                        value={comments}
                                                        onChange={handleInputChangeCash}
                                                        style={{ fontSize: "12px" }}
                                                    >
                                                    </textarea>
                                                </Col>
                                            </Row>


                                        </div>

                                    </div>
                            }
                        </Col>
                    </Row>
                </Col>
            </Dialog>
        </Fragment >
    )
}
